import React from "react";
import "../styles/common.css";

export default function DemoWebsiteTag() {
	return (
		<div id="demo-website">
			<p>This demo website fetches dummy data from my WordPress</p>
		</div>
	);
}
